<template>
  <div
    class="bash-wrap advantage-wrap"
    :style="'background:url(' + indata.bgcImage + ') no-repeat 50% 50%;'"
  >
    <div class="bash-box advantage-box">
      <p class="h2-title">{{ indata.FirstTitle }}</p>
      <ul class="advantage-ul">
        <li v-for="(item, index) in indata.children" :key="index">
          <div><img :src="item.image" alt="" /></div>
          <p>{{ item.title }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped src="../../public/css/drp.css">
</style>
<script>
export default {
  name: "Templates8",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
